export default "__VITE_ASSET__ByvH80eo__"